import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import Button from 'components/shared/Button/Button'
import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './BlockToText.scss'
import sliceImage from './images/image.svg'

const BlockToText = ({ t, gtm = {}, gtmLabel }) => {
  const sendDataToGTM = useGTMDispatch()
  const handleClick = () => {
    if (window.plausible) {
      window.plausible(`B2T Pathway Slice - ${gtmLabel}`)
    }
    sendDataToGTM({ ...gtm, gtmLabel })
  }

  return (
    <div className="block-to-text__wrapper">
      <div className="block-to-text">
        <div className="block-to-text__copy">
          <h3 className="block-to-text__copy--title">
            {t('project.block-to-text.title')}
          </h3>
          <p className="block-to-text__copy--description">
            {t('project.block-to-text.description')}
          </p>
          <Button
            type="primary"
            text={t('project.block-to-text.button')}
            href={'/en/exercises/paint-with-python'}
            onClick={handleClick}
            className="block-to-text__button"
          />
        </div>
        <img
          alt="Editor slice"
          className="block-to-text__image"
          src={sliceImage}
        />
      </div>
    </div>
  )
}

BlockToText.propTypes = {
  gtm: PropTypes.object,
  gtmLabel: PropTypes.string,
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(BlockToText)
